import React from 'react';
import Head from 'next/head';
import { useRouter } from 'next/router';
import { NextSeo } from 'next-seo';
import Navbar from '../../components/Navbars/AppNavbar.js';
import Footer from '../../components/Footers/Footer.js';
import FooterSM from '../../components/Footers/FooterSmall.js';
import BlogComponent from '../../components/Blog';

// The Storyblok Client
import Storyblok from '../../lib/storyblok';

export default function Article(props) {
  const router = useRouter();

  return (
    <>
      <Head>
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1, shrink-to-fit=no"
        />
        <link
          rel="canonical"
          href={`https://musicart.io/blog/${router.query.slug}`}
        />
      </Head>
      <>
        {router.query.slug &&
          props &&
          props.story &&
          props.story.content &&
          props.story.content.content &&
          props.story.content.content[0] && (
            <NextSeo
              title={props.story.content.content[0].title}
              description={props.story.content.content[0].intro_text}
              openGraph={{
                url: `https://musicart.io/nft/${router.query.slug}`,
                type: 'website',
                locale: 'en_IE',
                title: props.story.content.content[0].title,
                description: props.story.content.content[0].intro_text,
                images: [
                  {
                    url:
                      props.story.content.content[0] &&
                      props.story.content.content[0].image &&
                      props.story.content.content[0].image.filename
                        ? props.story.content.content[0].image.filename
                        : 'https://i.imgur.com/Q0kiEsg.jpg',
                  },
                ],
                site_name: 'MusicArt',
              }}
            />
          )}
      </>

      {/* {console.log("full", props)} */}
      <Navbar transparent />
      <BlogComponent
        full={true}
        story={props.story}
        stories={null}
        sidebar={props.sidebar}
      />
      <Footer />
      <FooterSM />
    </>
  );
}

export async function getServerSideProps(context) {
  const { slug } = context.query;

  let full_slug = `${slug}`;
  let sbParams = {
    version: 'draft', // or 'published' / ' draft
  };

  if (context.preview) {
    sbParams.version = 'draft';
    sbParams.cv = Date.now();
  }

  // load the stories insides the pages folder
  let { data } = await Storyblok.get(`cdn/stories/blog/${full_slug}`, sbParams);
  let sidebar = await Storyblok.get(`cdn/stories/blog/sidebar`);

  return {
    props: {
      story: data ? data.story : null,
      sidebar: sidebar.data,
      revalidate: 10,
    },
  };
}

// export async function getStaticPaths() {

//   let { data } = await Storyblok.get('cdn/links/', {
//       starts_with: 'article'
//   })

//   let paths = [];
//   Object.keys(data.links).forEach((linkKey) => {
//     // don't create routes for folders and the index page
//     if (data.links[linkKey].is_folder || data.links[linkKey].full_slug === "home") {
//       return;
//     }

//     // get array for slug because of catch all

//     const slug = data.links[linkKey].slug;

//     // remove the pages part from the slug
//     let newSlug = slug.replace('blog', '')
//     let splittedSlug = newSlug.split("/");

//     paths.push({ params: { slug: splittedSlug.toString() } });
//   });

//   return {
//     paths: paths,
//     fallback: false,
//   };
// }
